import React from "react";

/**
 * Shown instead of a quote form when the page was opened without an app session
 * (Ansa-Support#137). The quote journeys read their session token from `?token=`,
 * which only the ANSA app supplies, and the backend requires it on every quote
 * call — so a visitor arriving from www.ansa.my cannot get a quote here. Rather than
 * letting them fill in the form and fail at the first API call, point them at the
 * app, and at the website enquiry form as the no-app alternative.
 */
const APP_STORE_LINKS = [
	{ label: "App Store", href: "https://apps.apple.com/my/app/ansa-insurtech-fintech/id6744491420" },
	{ label: "Google Play", href: "https://play.google.com/store/apps/details?id=com.ansa_malaysia.ANSA" },
	{ label: "AppGallery", href: "https://appgallery.huawei.com/app/C113937507" },
];

const AppOnlyNotice = ({ title, body, enquiryText, enquiryLinkText, enquiryService }) => {
	const enquiryUrl = `https://www.ansa.my/enquiry/?service=${encodeURIComponent(enquiryService).replace(/%20/g, "+")}`;

	return (
		<div className="w-100 mt-10 text-left">
			<h3 className="mt-0 mb-0">{title}</h3>
			<p className="formatted-text">{body}</p>

			<div className="d-flex flex-row flex-wrap gap-2 mt-3">
				{APP_STORE_LINKS.map(({ label, href }) => (
					<a
						key={label}
						className="p-button p-button-outlined"
						href={href}
						target="_blank"
						rel="noopener noreferrer"
					>
						{label}
					</a>
				))}
			</div>

			<p className="formatted-text mt-4">
				{enquiryText}{" "}
				<a className="color-primary underline" href={enquiryUrl} target="_blank" rel="noopener noreferrer">
					{enquiryLinkText}
				</a>
			</p>
		</div>
	);
};

export default AppOnlyNotice;
